export const mamaLyrics = [
  { text: "You have to understand how things are up here", start: 0, end: 2.1 },
  { text: "Mmm", start: 12, end: 13 },
  { text: "Mmm", start: 15, end: 17 },
  { text: "Mmm", start: 17, end: 20 },
  { text: "Mama was a strong woman", start: 23.5, end: 27.89 },
  { text: "She never knew peace", start: 27.89, end: 30.7 },
  { text: "Mama was a strong woman", start: 30.7, end: 34.2 },
  { text: "You better take heed after me", start: 34.2, end: 37.9 },
  { text: "Hoo", start: 37.9, end: 39 },
  { text: "Hoo", start: 39, end: 40.5 },
  { text: "Hoo", start: 40.5, end: 42 },
  { text: "Hoo", start: 42, end: 43.5 },
  { text: "Hoo", start: 43.5, end: 45 },
  { text: "Hoo", start: 45, end: 46.5 },
  { text: "Hoo", start: 46.5, end: 48.5 },
  { text: "Hoo", start: 48.5, end: 50 },
  { text: "I went to church on Sunday", start: 50, end: 52.7 },
  { text: "Still in danger", start: 52.7, end: 55.5 },
  { text: "Pastor said he can't set me free", start: 55.5, end: 60.22 },
  { text: "Free", start: 60.22, end: 63.2 },
  { text: "Can't get no rest", start: 63.2, end: 65.26 },
  { text: "Monday through Sunday", start: 66.4, end: 68.3 },
  { text: "Sunday", start: 68.3, end: 69 },
  { text: "I've got too many mouths to feed", start: 69, end: 73.2 },
  { text: "Oh like a thief in the night", start: 73.2, end: 77.27 },
  { text: "I could hear my mother's cry", start: 77.27, end: 80 },
  { text: "She'd beg and plead", start: 80, end: 82.2 },
  { text: "Beg and plead", start: 82.2, end: 85.44 },
  { text: "I heard sirens in her cries", start: 85.44, end: 90.113 },
  { text: "Waiting for the sun to rise", start: 90.113, end: 93 },
  { text: "She'd say lord have mercy on me", start: 93, end: 99.13 },
  { text: "Mama was a strong woman", start: 99.13, end: 103.129 },
  { text: "She never knew peace", start: 103.129, end: 105.98 },
  { text: "Mama was a strong woman", start: 105.98, end: 109.21 },
  { text: "You better take heed after me", start: 109.21, end: 113.51 },
  { text: "Hoo", start: 113.51, end: 114.8 },
  { text: "Hoo", start: 114.8, end:117  },
  { text: "Hoo", start: 117, end: 118.5 },
  { text: "Hoo", start: 118.5, end: 120 },
  { text: "Hoo", start: 120, end: 121.5 },
  { text: "Hoo", start: 121.5, end: 123 },
  { text: "Hoo", start: 123, end: 124.5 },
  { text: "Hoo", start: 124.5, end: 126 },
  { text: "I think I've ran out of mercy", start: 126, end: 128.9 },
  { text: "Can't take much more", start: 128.9, end: 131.4 },
  { text: "Constantly living in worry", start: 131.4, end: 135.1 },
  { text: "Of what's in store", start: 135.1, end: 137.18 },
  { text: "I'm feeling far away", start: 137.18, end: 141.99 },
  { text: "Of my own mind", start: 141.99, end: 143.6 },
  { text: "But I refuse to succumb to the confines on my own mind", start: 143.6, end: 149.5 },
  { text: "So I", start: 149.5, end: 150.9 },
  { text: "Shoes just can't catch her feet", start: 150.9, end: 153.65 },
  { text: "I can't get no release", start: 153.65, end: 157 },
  { text: "Oh mama mama mama", start: 157, end: 160 },
  { text: "Mama", start: 160, end: 163 },
  { text: "Mama was a strong woman", start: 163, end: 165.8 },
  { text: "She never knew peace", start: 165.8, end: 168.7 },
  { text: "Never knew peace" },
  { text: "Mama was a strong woman", start: 168.7, end: 171.88 },
  { text: "You better take heed after me", start: 171.88, end: 176.37 },
  { text: "Hoo", start: 176.3, end: 177.7 },
  { text: "Hoo", start: 177.7, end: 180 },
  { text: "Hoo", start: 180, end: 182.5 },
  { text: "Hoo", start: 182.5, end: 184 },
  { text: "Hoo", start: 184, end: 185.5 },
  { text: "Hoo", start: 185.5, end: 187 },
  { text: "Hoo", start: 187, end: 188.5 },
  { text: "Hoo", start: 188.5, end: 190 },
] as const satisfies ReadonlyArray<{ readonly text: string, readonly start?: number, readonly end?: number }>;
